import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import 'react-overlay-loader/styles.css';

// NaranciaSubHeader
const NaranciaSubHeader = (props) => {

  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  let navigate = useNavigate();
  let [pathname, setPathname] = useState('');

  useEffect(() => {
    setPathname(window.location.pathname)
  }, [window.location.pathname]);

  let selectedColor = '#000000'

  return (
    <div style={{
      paddingTop: 20,
      paddingBottom: 20,
    }}>
      <Container>

        <Row style={{
          fontSize: 15,
        }}>

          <Col md="12" xs="12" style={{
            textAlign: 'right',
          }}>

            <Link to="/narancia_top" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/narancia_top' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>トップ</Link>

            <Link to="/narancia_upload" style={{
              marginRight: 10,
              textDecoration: 'none',
              color: pathname === '/narancia_upload' ? selectedColor : '#777777',
              fontWeight: 'bold',
            }}>アップロード</Link>

          </Col>
        </Row>

      </Container>
    </div>
  )
}

export default NaranciaSubHeader
